export default function updateAction(globalSate, payload) {
  return {
    ...globalSate,
    checkoutDetails: {
      ...globalSate.checkoutDetails,
      ...payload,
    },
  };
}
